import React from 'react'
import { Box, Grid, SxProps, useMediaQuery, useTheme } from '@mui/material'

type ContentLayoutProps = {
	LeftSide?: React.ReactNode
	RightSide?: React.ReactNode
	BreadCrumbsTrail?: React.ReactNode
	children?: React.ReactNode
	sx?: SxProps
	hideOnMobile?: 'left' | 'right' | 'none'
}

export default function ContentLayout({
	LeftSide,
	RightSide,
	BreadCrumbsTrail,
	children,
	sx,
	hideOnMobile = 'none',
}: ContentLayoutProps) {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const shouldRenderLeftSide = !(isMobile && hideOnMobile === 'left')
	const shouldRenderRightSide = !(isMobile && hideOnMobile === 'right')

	return (
		<Box sx={{ width: '100%' }}>
			{BreadCrumbsTrail}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					mt: '10vh',
					...sx,
				}}
			>
				<Grid container>
					<Grid item xs={2} />
					<Grid item xs={9} sx={{ display: 'flex' }}>
						{shouldRenderLeftSide && LeftSide}
						{shouldRenderRightSide && RightSide}
						{children}
					</Grid>
					<Grid item xs={2} />
				</Grid>
			</Box>
		</Box>
	)
}
